import { useMutation } from '@tanstack/react-query';

import type { UpdateUserEnvironmentsArgs } from 'app/Domain/Users/Services';
import { userService } from 'app/Domain/Users/Services';

const mutationFn = (data: UpdateUserEnvironmentsArgs) => userService.updateUserEnvironments(data);

export const useUserUpdateEnvironmentsMutation = () =>
  useMutation<unknown, unknown, UpdateUserEnvironmentsArgs>(mutationFn);
